import { useQuery } from '@tanstack/react-query';
import { schoolsAPI } from '../../api';
import { School } from '../../types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

interface SchoolFilterProps {
  selectedSchoolId: string;
  onSchoolChange: (schoolId: string) => void;
}

export function SchoolFilter({ selectedSchoolId, onSchoolChange }: SchoolFilterProps) {
  // Fetch schools data
  const { 
    data: schoolsData,
    isLoading
  } = useQuery({
    queryKey: ['schools-filter'],
    queryFn: schoolsAPI.getAllSchools,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const schools = Array.isArray(schoolsData) ? schoolsData : [];

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm font-medium">School:</span>
      <Select
        value={selectedSchoolId || "all"}
        onValueChange={(value: string) => onSchoolChange(value === "all" ? "" : value)}
        disabled={isLoading}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="All Schools" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Schools</SelectItem>
          {schools.map((school: School) => (
            <SelectItem key={school._id} value={school._id}>
              {school.display_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}   